import React from 'react';
import { EditorState, Modifier } from 'draft-js';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';
import { toast } from 'react-toastify';

export const CustomFieldModal = ({
  collectionId,
  collections,
  addFieldsModal,
  toggleAddFieldsModal,
  editorState,
  onChange,
  projectDetail,
  insertText,
}) => {
  const copyToClipboard = () => {
    toggleAddFieldsModal();
    toast.success('Copied to clipboard');
  };

  const insertTextToParamInput = (textToInsert) => {
    console.log('\n Hit \n');
    if (textToInsert) {
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        textToInsert,
        editorState.getCurrentInlineStyle(),
      );
      onChange(EditorState.push(editorState, contentState, 'insert-characters'));
      toggleAddFieldsModal();
      toast.success('Text Inserted');
    }
  };

  const showAddFieldsModal = () => {
    const selectedCollection = collections.find((coll) => coll.collectionName === collectionId);
    return addFieldsModal ? (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={copyToClipboard}
        insertTextToEditor={insertText ? insertText : insertTextToParamInput}
        toggleFields={addFieldsModal}
        toggleFieldsModal={toggleAddFieldsModal}
        hide={[
          'collectionConstants',
          'projectConstants',
          'authToken',
          'tenantFields',
          'userSettingFields',
          'subTenantFields',
        ]}
      />
    ) : (
      ''
    );
  };
  return (
    <div className="input-group-text align-items-end px-0">
      {showAddFieldsModal()}
      <button
        type="button"
        className="btn btn-theme-submit btn-xs btn-icon-only"
        title="Add Fields"
        onClick={toggleAddFieldsModal}
      >
        <i className="wb webconnect-plus" />
      </button>
    </div>
  );
};
